const config = require("config");

(function () {
  var controllerId = "routeController";

  angular
    .module("app")
    .controller("routeController", routeController);

  routeController.$inject = [
    "$scope",
    "$rootScope",
    "$window",
    "$sce",
    "_",
    "$filter",
    "alkGeocodeService",
    "routeService",
    "mapService",
    "userService",
    "alkModalService",
    "LocationItem",
    "UserProvider",
    "vehicleService",
    "alkImportService",
    "$translate",
    "$q",
    "routeSyncErrors",
    "stopService",
    "routeExceptionsLayerService",
    "eventTracker",
    "favoriteLocationsService"
  ];

  function routeController($scope, $rootScope, $window, $sce, _, $filter, alkGeocodeService, routeService, mapService,
    userService, alkModalService, LocationItem, userProvider, vehicleService,
    alkImportService, $translate, $q, routeSyncErrors, stopService, routeExceptionsLayerService, eventTracker,
    favoriteLocationsService) {

    var routeVm = this;
    routeVm.addWarnings = addWarnings;
    routeVm.cancelArrDep = cancelArrDep;
    routeVm.canSaveFavorite = canSaveFavorite;
    routeVm.canSavePopupFavorite = canSavePopupFavorite;
    routeVm.savePopupFavorite = savePopupFavorite;
    routeVm.canSaveRoute = canSaveRoute;
    routeVm.canSaveRoutePopupFavourite = canSaveRoutePopupFavourite;
    routeVm.canSendRoute = false;
    routeVm.changeTraffic = changeTraffic;
    routeVm.clearRoute = clearRoute;
    routeVm.duplicateRoute = duplicateRoute;
    routeVm.deleteRoute = deleteRoute;
    routeVm.deleteStop = deleteStop;
    routeVm.saveAndDeleteStopModal = saveAndDeleteStopModal;
    routeVm.dropdownStatus = {};
    routeVm.frameRoute = frameRoute;
    routeVm.getRoute = (routeId) => routeService.getRoute(routeId);
    routeVm.getDurationInHHMM = getDurationInHHMM;
    routeVm.hasRoutes = () => routeService.hasRoutes();
    routeVm.hideRouteSync = hideRouteSync;
    routeVm.isRouteSyncPanelVisible = false;
    routeVm.lightenRouteColor = (route, num) => $filter("colorFilter")(route.color, "lighten", num);
    routeVm.mapId = "pcmMap";
    routeVm.optimizeStopOrder = optimizeStopOrder;
    routeVm.optionsUI = routeService.getOptionsUI();
    routeVm.routes = routeService.getAllRoutes();
    routeVm.routeCount = routeCount;
    routeVm.newRoute = newRoute;
    routeVm.runRoute = runRoute;
    routeVm.saveFavorite = saveFavorite;
    routeVm.saveRoute = saveRoute;
    routeVm.selectRoute = selectRoute;
    routeVm.showLeastCost = showLeastCost;
    routeVm.showLocation = showLocation;
    routeVm.showImportStops = showImportStops;
    routeVm.showOptions = showOptions;
    routeVm.showReports = showReports;
    routeVm.stopTimeClick = stopTimeClick;
    routeVm.stopTimeCancel = stopTimeCancel;
    routeVm.stopTimeSave = stopTimeSave;
    routeVm.moveSearchPanel = moveSearchPanel;
    routeVm.showRouteSync = showRouteSync;
    routeVm.tempStop = null;
    routeVm.toggleRouteVisibility = toggleRouteVisibility;
    routeVm.uiRoutingOpt = ["Practical", "Shortest", "Fastest"];
    routeVm.uiArrDepOpt = ["None", "Arrive", "Depart At", "Depart By"];
    routeVm.uiTollRoads = ["Use Tolls", "Avoid Tolls"];
    routeVm.shouldAllowRouteSync = shouldAllowRouteSync;
    routeVm.getRouteSyncErrors = getRouteSyncErrors;
    routeVm.isDurationValid = isDurationValid;
    routeVm.canSaveDurations = canSaveDurations;
    routeVm.onSortableUpdate = onSortableUpdate;
    routeVm.region = userProvider.getUser().region;
    routeVm.dataset = userProvider.getUser().dataset;
    routeVm.watchTraffic = watchTraffic;
    routeVm.addSelectedLocationToRoute = addSelectedLocationToRoute;
    routeVm.popupLocation = null;
    routeVm.hasAvoidFavors = hasAvoidFavors;
    routeVm.shouldShowAvoidFavors = shouldShowAvoidFavors;
    init();

    ////////////////

    function init() {
      routeService.reloadRoutes();
      addWarnings();
    }

    /// Route Functions ///

    function canSaveFavorite(loc) {
      return favoriteLocationsService.canSave(loc);
    }

    function hasAvoidFavors() {
      return routeExceptionsLayerService.hasAvoidFavors();
    }

    function shouldShowAvoidFavors() {
      return routeExceptionsLayerService.hasAvoidFavors() && routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    function cancelArrDep($event) {
      //console.log($event);
      angular.element(".arrDepDropdown").dropdown("toggle");
    }

    function canSaveRoute(route) {
      return ((route.isValidRoute()) && (userService.canSaveRoute(angular.copy(route.stops), angular.copy(route.options))));
    }

    function changeTraffic(route) {
      // do not change it to depart now if check useTraffic SWPWEB-818
      // if (route.options.useTraffic) {
      //   route.uiArrDepSelection.type = "now";
      //   route.uiArrDepSelection.datetype = "now";
      // }
      route.applyArrDep();
    }
    function watchTraffic(route) {
      if (route.uiArrDepSelection.type === "None") {
        route.options.useTraffic = false;
      }
    }

    function clearRoute(route) {
      mapService.removeRoute(route.id, routeVm.mapId);
    }

    function duplicateRoute(route) {
      eventTracker.track("Clicks Duplicate Route");

      if (!route) {
        return;
      }
      var duplicatedRoute = {};
      duplicatedRoute.name = `${route.name} - Copy`;
      duplicatedRoute.options = angular.copy(route.options);
      duplicatedRoute.stops = angular.copy(route.stops);
      duplicatedRoute.uiArrDepSelection = angular.copy(route.uiArrDepSelection);
      duplicatedRoute.isDuplicatedRoute = true;
      $rootScope.$broadcast("NewRoute", duplicatedRoute);
    }

    function deleteRoute(route) {
      alkModalService.show({
        size: "sm"
      }, {
        headerText: "Delete Route",
        bodyText: "Are you sure you want to delete this route?"
      }).then(() => {
        mapService.deleteRoute(route.id, routeVm.mapId);
        var idx = routeService.deleteRoute(route.id);
        var selectThisRoute = null;
        if (idx <= routeVm.routes.length - 1) {
          selectThisRoute = routeVm.routes[idx];
        } else if (idx > routeVm.routes.length - 1 && routeVm.routes.length > 0) {
          selectThisRoute = routeVm.routes[routeVm.routes.length - 1];
        }

        if (selectThisRoute !== null) {
          setTimeout(() => {
            $scope.$apply(() => {
              routeVm.selectRoute(selectThisRoute);
            });
          }, 500);
        } else {
          newRoute();
        }
      });
    }

    function frameRoute(r) {
      mapService.frameRoute(r.id, routeVm.mapId);
    }

    function optimizeStopOrder(opt, route) {
      if (opt === 1 && route.stops.length >= 3 || opt === 2 && route.stops.length >= 4)  {
        var previousOptimization = route.options.routeOptimization;
        route.options.routeOptimization = opt;
        var optimizeStopOrderPromise = routeService.optimizeStopOrderPromise(opt, route);
        optimizeStopOrderPromise.then(() => {
          route.options.routeOptimization = previousOptimization;
        },
        () => {
          route.options.routeOptimization = previousOptimization;
        });
      }
    }

    function runRoute(route) {
      routeVm.hideRouteSync();
      if (route === undefined) {
        route = routeService.getSelectedRoute();
      }
      //console.log("Trigger from routeControoler :: runRoute", route);

      if (route.isValidRoute()) {
        routeService.runRoute(route);
      } else {
        mapService.removeRoute(route.id, routeVm.mapId);
        mapService.updateRouteMarkers(route.id, route.color, route.stops, route.options);
        route.clearTotals();
      }
      addWarnings();
    }

    function saveNewRoute(route) {
      const savedRoute = userService.getSavedRoutes();
      if (savedRoute.length >= userService.getSaveRouteLimit()) {
        alkModalService.show({
          size: "sm",
          templateUrl: "/app/route/showLimitError.template.html",
        });
      } else {
        alkModalService.show({
          size: "sm",
          templateUrl: "/app/route/saveRoute.template.html",
          controller: ["$scope", "$uibModalInstance", function($scope,$uibModalInstance) {
            $scope.route = {};

            $scope.ok = function (isValid) {
              if (!isValid) {
                return;
              }

              $scope.isCheckingRouteName = true;
              $scope.isRouteNameDuplicate = false;

              routeService.isRouteUnique($scope.route.name).then(() => {
                $uibModalInstance.close($scope.route.name);
              }).catch(() => {
                $scope.isRouteNameDuplicate = true;
              }).finally(() => {
                $scope.isCheckingRouteName = false;
              });
            };

            $scope.isFocused = true;

            $scope.close = function () {
              $uibModalInstance.dismiss("cancel");
            };
          }]
        }).then((routeName) => {
          userService.saveRoute(route.stops, route.options, routeName).then((savedRoute) => {
            route.savedId = savedRoute.savedId;
            route.name = savedRoute.name;
            userService.getSavedTrip(savedRoute.savedId).then((tripResponse)=>{
              if (tripResponse.length) {
                route.options.routingProfileId = tripResponse[0].Profile.routingProfileId;
                routeService.saveSessionRoute(route);
              }
            });
          });
        });
      }
    }

    function saveRoute(route) {
      if (route.savedId) {
        // display update route modal
        updateRoute(route);
      }  else {
        // display save new route modal
        saveNewRoute(route);
      }
    }

    function selectRoute(r) {
      routeVm.hideRouteSync();
      routeService.selectRoute(r);
      if (r.isValidRoute()) {
        routeVm.frameRoute(r);
      }
    }

    function showLeastCost(route) {
      alkModalService.show({
        size: "lg",
        templateUrl: "/app/modal/dialog.template.html",
        controller: "leastCostModalController",
        resolve: {
          data: function () {
            return {
              route: route //,
              //baseMap: mapService.cloneBaseMap(),
              //trafficLayer: mapService.cloneTrafficLayer()
            };
          }
        }
      }).then((result) => {
        if (route.options.routingType !== result.routingType || route.options.tollDiscourage !== result.tollDiscourage) {
          route.options.tollDiscourage = result.tollDiscourage;
          route.options.routingType = result.routingType;
          routeVm.runRoute(route);
        }
      });
    }

    function stopTimeClick(route) {
      route.stopTime = true;
      route.setOrigStopTimes();
    }

    function stopTimeCancel(route) {
      route.stopTime = false;
      route.revertStopTimes();
      routeService.runRoute(route);
    }

    function stopTimeSave(route) {
      route.stopTime = false;
      routeService.runRoute(route);
    }

    function toggleRouteVisibility(r) {
      if (r.isVisible) {
        mapService.hideRoute(r.id, routeVm.mapId);
        r.isVisible = false;
      } else {
        mapService.showRoute(r.id, routeVm.mapId);
        r.isVisible = true;
      }
    }

    function updateRoute(route) {
      alkModalService.show({
        size: "sm",
        templateUrl: "/app/route/updateRoute.template.html",
        controller: ["$scope", "$uibModalInstance", "route", function ($scope, $uibModalInstance, route) {
          $scope.route = {};

          $scope.ok = function () {
            $uibModalInstance.close();
          };

          $scope.route = route;

          $scope.close = function () {
            $uibModalInstance.dismiss("cancel");

            // display popup for saving new route
            saveNewRoute(route);
          };
        }],
        resolve: {
          route: function () {
            return route;
          }
        }
      }).then(() => {
        userService.updateRoute(route).then((savedRoute) => {
          routeService.saveSessionRoute(savedRoute);
        });
      });
    }

    /// Stop Functions ///

    function deleteStop(stop) {

      routeService.deleteStop(stop);
    }

    function saveAndDeleteStopModal(lat,long,isDelete)
    {
      var selectedRoute = routeService.getSelectedRoute();
      var currentStop = selectedRoute.stops.filter(x=>x.smLonLat.lat==lat && x.smLonLat.lon==long);
      if(currentStop!=undefined && currentStop.length){
        if(isDelete)
        {
          routeService.deleteStop(currentStop[0]);
        }
        else{
          routeVm.saveFavorite(currentStop[0]);
        }
      }
    }

    function canSaveRoutePopupFavourite()
    {

      // var disableFavorite = true;
      // var selectedRoute = routeService.getSelectedRoute();
      // var currentStop = selectedRoute.stops.filter(x=>x.smLonLat.lat==lat && x.smLonLat.lon==long);
      // if(currentStop!=undefined && currentStop.length){
      //   // routeVm.saveFavorite(currentStop[0]);
      //   disableFavorite=favoriteLocationsService.canSave(currentStop[0]);


      // }
      //  return disableFavorite;
      var issave = routeVm.canSaveFavorite(routeVm.popupLocation);
      if(issave)
      {
        return "";
      }
      else
      {
        return "cursor: not-allowed;pointer-events: none;color: #c0c0c0;background-color: #ffffff;";
      }
    }


    function isDurationValid(str) {
      if (!str || stopService.getHoursFromString(str) !== null) {
        return true;
      } else {
        return false;
      }
    }

    function canSaveDurations(route) {
      for (var stop of route.stops) {
        if (!isDurationValid(stop.duration)) {
          return false;
        }
      }
      return true;
    }

    function onSortableUpdate() {
      $rootScope.$broadcast("FocusSearchField");
    }

    function getDurationInHHMM(stop) {
      return stopService.getDurationInHHMM(stop.duration);
    }

    function saveFavorite(loc) {

      alkModalService.show({
        size: "sm",
        templateUrl: "/app/modal/favoriteDialog.template.html",
        controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
          $scope.location = {
            isShared: false
          };

          $scope.ok = function (isValid) {

            if (isValid) {
              $uibModalInstance.close($scope.location);
            }
          };

          $scope.isFocused = true;

          $scope.close = function () {
            $uibModalInstance.dismiss("cancel");
          };
        }]
      }).then((location) => {
        favoriteLocationsService.saveNew(angular.copy(loc), location.name, location.isShared);
      });
    }

    function showLocation(loc) {
      //$rootScope.$broadcast("ShowLocation", loc);
      mapService.panToLocation(loc, routeVm.mapId);
    }

    //Options for ui-sortable directive (drag/drop stops)
    routeVm.sortableOptions = {
      update: function ( /*e, ui*/ ) {},
      stop: function (e, ui) {
        // will find a better way to check if it's the search panel that gets moved.
        if (ui.item[0].innerText.indexOf("Add Stop") === -1) {
          // this callback has the changed model
          var selectedRoute = routeService.getSelectedRoute();
          selectedRoute.syncSortableItemsToStops();
          selectedRoute.updateStopIcons();
          routeVm.runRoute();
        }
      },
      axis: "y",
      items: ".sort-item"
    };

    /// Map Popup Functions ///
    function addSelectedLocationToRoute () {
      $rootScope.$broadcast("AddStop", routeVm.popupLocation);
    }

    function canSavePopupFavorite() {
      return routeVm.canSaveFavorite(routeVm.popupLocation);
    }

    function savePopupFavorite() {

      routeVm.saveFavorite(routeVm.popupLocation);
    }

    /// Search Functions ///
    function moveSearchPanel(index) {
      var selectedRoute = routeService.getSelectedRoute();
      var searchIndex = selectedRoute.getSearchPanelIndex();
      // if search panel is currently below the position to move to.
      if (searchIndex === -1 || searchIndex > index) {
        selectedRoute.syncStopsToSortableItems(index, true);
      } else { // if search panel is currently above the position to move to.
        selectedRoute.syncStopsToSortableItems(index - 1, true);
      }
    }

    /// Options Functions ///

    function showOptions(route) {
      alkModalService.show({
        size: "lg",
        templateUrl: "/app/route/options.template.html",
        controller: "routeOptionModalController as vm",
        resolve: {
          routeCopy: function () {
            return angular.copy(route);
          },
          optionsUI: function () {
            return routeService.getOptionsUI();
          },
          subscriptionLevel: function () {
            return userProvider.getUser().subscriptionLevel;
          },
          isDefault: function () {
            return false;
          }
        }
      }).then((result) => {
        var orig = angular.copy(route);

        route.options = result.options;
        route.uiArrDepSelection = result.uiArrDepSelection;
        // after modifying the route, get a copy of it to determine if was changed.
        var copy = angular.copy(route);

        // after the copy is taken, we can set the name since name changes won't affect if the route should be re-run
        route.name = result.name;

        if (angular.equals(copy, orig) !== true) {
          route.applyArrDep();
        }
      });
    }

    /// Report Functions ///

    function showReports(route) {
      var thisWin = routeService.getReportWindow(route.id);
      if (thisWin === null || thisWin.closed) {
        routeService.newReportWindow(route);
      } else {
        thisWin.focus();
      }
      eventTracker.track("Reports");
    }

    /// RouteSync Functions ///

    function shouldAllowRouteSync() {
      return routeSyncErrors.areRouteOptionsValid(routeService.getSelectedRoute());
    }

    function getRouteSyncErrors() {
      return routeSyncErrors.getErrorsFromRouteOptions(routeService.getSelectedRoute());
    }

    function showRouteSync() {
      if (shouldAllowRouteSync()) {
        routeVm.isRouteSyncPanelVisible = true;
      }
    }

    function hideRouteSync() {
      routeVm.isRouteSyncPanelVisible = false;
      $rootScope.$broadcast("routeSyncHidden");
    }

    function routeCount() {
      return routeService.getAllRoutes().length;
    }

    function newRoute() {
      $rootScope.$broadcast("NewRoute");
      $rootScope.$broadcast("FocusSearchField");
      hideRouteSync();
    }

    function addWarnings() {
      routeVm.routes.forEach(route => {
        let addtion = 0;
        route.warnings = [];
        mapService.addReport(route.id, route.stops, route.options, route.uiArrDepSelection, "Directions", (response) => {
          response[0].ReportLegs.forEach((leg, index) => {
            let warningText = [];
            let warningFinal = [];
            let warning = false;
            leg.ReportLines.forEach(line => {
              // combine all warnings per leg
              if (line.Direction && line.Direction.includes("Warning - ")) {
                warning = true;
                warningText = line.Direction.replace("Warning - ", "");
                warningText = warningText.split(";");

                let temp = [];
                warningText.forEach(text => {
                  temp = text.split(":");
                  temp[0] = temp[0].trim();
                  warningText.push(temp[0]);
                });
                warningText.splice(0, (warningText.length / 2));
                warningFinal = _.union(warningFinal, warningText);
              }
            });
            warningFinal = warningFinal.join(", ");
            warningFinal = `Warning: ${warningFinal}`;
            if (warning) {
              addtion++;
              let i = index + addtion;
              route.warnings.push({
                type: "warning",
                index: i,
                legIndex: index,
                text: warningFinal
              });
            }
          });

        }, (err) => {
        });
      });
    }

    /// Import Functions ///

    //Launches the 3-modal popup
    function showImportStops() {

      var oldBrowser = alkImportService.browserImportIncompatible();

      var firstModal = {
        modalOptions: {
          size: "sm",
          template: require("./../../Common JavaScript Files/AngularJS/alk-import/importModal.html"),
          controller: "importModalController",

          controllerAs: "vm",
          backdrop: oldBrowser ? true : "static",

        },
        onModalSuccess: function () {
          alkModalService.openNextModal();
        }
      };

      var secondModal = {
        modalOptions: {
          size: "md",
          template: require("./../../Common JavaScript Files/AngularJS/alk-import/importFieldsModal.html"),
          controller: "importFieldsModalController",
          resolve: {
            data: function () {
              const route = routeService.getSelectedRoute();

              return {
                checkHistoricalVersion :  routeService.checkHistoricalVersion(route.options.dataVersion)
                //baseMap: mapService.cloneBaseMap(),
                //trafficLayer: mapService.cloneTrafficLayer()
              };
            }
          },
          controllerAs: "vm",
          backdrop: "static",
        },
        onModalSuccess: function (res) {
          //Back clicked
          if (res.back) {
            alkModalService.openPrevModal();
            return;
          } else if (res.wasGeocoded) {
            //Call third modal
            alkModalService.openNextModal();
          } else {
            //Code that runs after import completes
          }
        }
      };

      var thirdModal = {
        modalOptions: {
          size: "lg",
          template: require("./../../Common JavaScript Files/AngularJS/alk-import/importAddressModal.html"),
          controller: "importAddressModalController",
          controllerAs: "vm",
          backdrop: "static",

        },
        onModalSuccess: function (res) {
          //Call fourth modal
          if (res.back) {
            alkModalService.openPrevModal();
          }
          else {
            alkModalService.openNextModal();
          }
        }
      };

      var fourthModal = {
        modalOptions: {
          size: "sm",
          template: require("./../../Common JavaScript Files/AngularJS/alk-import/importDetailsModal.html"),
          controller: "importDetailsModalController",
          controllerAs: "vm",
          backdrop: "static"
        },
        onModalSuccess: function (res) {
          //Back clicked
          if (res.back) {
            alkModalService.openPrevModal();
          } else {
            //Code that runs after import completes
          }
        }
      };
      var wizardData = {
        importFeatureType: "PCMWebUIStops",
        importFunction: importStops, //Callback for import function
        onShowMap: function (result) {
          //Callback that happens when "Show Map" button clicked on geocode results modal popup
          //result will have a Coords object with Lat/Lon
          mapService.showPin(result, true, $scope, routeVm.mapId, true);
        },
        onShowList: function () {
          //Callback that happens when "Show List" button clicked on geocode results modal popup (after clicking "Show Map")
          //Delete the marker/popup created if there was one
          mapService.clearSearchMarker(routeVm.mapId);
        },
        callback: function (result) {
          //Runs after the import is done and wizard is closed.
        }
      };

      alkModalService.initiateModalWizard([firstModal, secondModal, thirdModal, fourthModal], wizardData);
    }

    //importRows will be popuplated with an array of objects whose keys match the import field object's name properties set (see alkImportService.js)
    //i.e. StopName, StreetAddress, City, State, Zip, Country, EstimatedDuration, EarliestArrivalTime, LatestArrivalTime.
    //importType returns 0 for append, 1 for replace, in function above
    function importStops(importRows, importType) {

      var promises = [];
      var tempStops = [];

      //Replace stops - delete them all first
      if (importType === 1) {
        var route = routeService.getSelectedRoute();
        route.deleteAllStops();
      }

      for (const importRow of importRows) {

        var address = {
          StreetAddress: importRow.StreetAddress ? importRow.StreetAddress : "",
          City: importRow.City ? importRow.City : "",
          State: importRow.State ? importRow.State : "",
          Zip: importRow.Zip ? importRow.Zip : "",
          County: importRow.County ? importRow.County : "",
          Country: importRow.Country ? importRow.Country : ""
        };
        var coords = {
          Lat: String(importRow.Latitude),
          Lon: String(importRow.Longitude)
        };

        const importName = importRow.StopName ? importRow.StopName : "";

        const stop = new LocationItem({
          Address: address,
          Coords: coords,
          PlaceName: importName,
          duration: importRow.EstimatedDuration,
          earliestArrivalTime: importRow.EarliestArrivalTime,
          latestArrivalTime: importRow.LatestArrivalTime
        }, importName);
        stop.origLatlon = false; // SWPWEB-1334, use addr only
        tempStops.push(stop);
      }

      routeService.addStop(tempStops, routeService.getSelectedRoute());

      //Must return a promise for the import modal service callback, even if not asynchronous
      return $q.all(promises);
    }

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
    $scope.$on("DeleteAllRoutes", () => {
      mapService.deleteAllRoutes(routeVm.mapId);
      routeService.deleteAllRoutes();
      routeVm.routes = routeService.getAllRoutes();
    });
    $scope.$on("AddStop", (event, message) => {
      var selectedRoute = routeService.getSelectedRoute();

      function addStop(stop, isRouteDraggable) {
        routeService.setDraggable(isRouteDraggable);
        routeService.addStop(stop, selectedRoute);

        var hadMarker = mapService.clearSearchMarker(routeVm.mapId);
        mapService.clearPlaceSearchMarker(routeVm.mapId);
        //show stops that are outside of viewport
        if ((!hadMarker) && (selectedRoute !== null) && (selectedRoute.stops.length === 1)) {
          routeVm.showLocation(stop);
        }
      }

      if (!userProvider.getUser().isPremium()) {
        if ((selectedRoute !== null) && (selectedRoute.stops.length >= 10)) {

          alkModalService.show({
            size: "sm",
            backdrop: true
          }, {
            headerText: "Maximum Stops Reached",
            bodyText: "You need a Premium Subscription to add more than 10 stops to a route.",
            okOnly: true
          }).then((result) => {

          });

          eventTracker.track("Maximum Stops Reached");

          mapService.clearSearchMarker(routeVm.mapId);
          return;
        }

        // If the passed in stop doesn't have a street address, there is no need to perform another geocode.
        if (!message.Address.StreetAddress) {
          addStop(message, false);
        } else {
          var dataset = routeService.getDataset();
          //convert full location to ZIP based
          //geocode
          var geoOpt = {
            listSize: 1,
            region: routeVm.region,
            dataset: dataset
          };
          alkGeocodeService.geocode({
            city: message.Address.City,
            state: message.Address.State,
            zip: message.Address.Zip
          }, geoOpt).then((r) => {
            //add stop
            var newLoc = new LocationItem(r[0]);
            addStop(newLoc, false);

          }).catch((err) => {
            console.log("Error");
          });
        }
      } else {
        addStop(message, true);
      }
    });

    $scope.$on("MapClick", (event, message) => { // jshint ignore:line
      routeVm.popupLocation = null;
      var dataset = routeService.getDataset();
      var transformedLonLat = mapService.transformFromSphericalMercator(message, routeVm.mapId);
      alkGeocodeService.reverseGeocode(transformedLonLat, {dataset: dataset, region: routeVm.region})
        .then((r) => {
          // store coords from map event if user clicks on map, SWPWEB-1302
          r[0].origLatlon = `${transformedLonLat.lat}, ${transformedLonLat.lon}`;
          var newLoc = new LocationItem(r[0]);
          // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
          if(newLoc && newLoc.Coords && newLoc.Coords.Lat && !newLoc.Coords.Lat.includes(".")) {
            var hasNegative = newLoc.Coords.Lat.includes("-");
            var indexPosition = hasNegative ? newLoc.Coords.Lat.length > 9 ? 4 : 3 
                                            : newLoc.Coords.Lat.length > 8 ? 3 : 2;
            newLoc.Coords.Lat =   newLoc.Coords.Lat.substring(0, indexPosition)
            + "." + newLoc.Coords.Lat.substring(indexPosition);
          }
          if(newLoc && newLoc.Coords && newLoc.Coords.Lon && !newLoc.Coords.Lon.includes(".")) {
            var hasNegative = newLoc.Coords.Lon.includes("-");
            var indexPosition = hasNegative ? newLoc.Coords.Lon.length > 9 ? 4 : 3 
                                            : newLoc.Coords.Lon.length > 8 ? 3 : 2;
            newLoc.Coords.Lon = newLoc.Coords.Lon.substring(0, indexPosition)
            + "." + newLoc.Coords.Lon.substring(indexPosition);
          }
          // Ends Temporary fix
          routeVm.popupLocation = newLoc;
          mapService.showPin(newLoc, false, $scope, routeVm.mapId);
        });
    });

    $scope.$on("MapPlaceClick", (event, message) => { // jshint ignore:line
      routeVm.popupLocation = message;
      mapService.showPlacePin(message, $scope, routeVm.mapId);

    });

    $scope.$on("MapPlaceHover", (event, message) => {
      mapService.showPlaceHoverPopup(message, $scope, routeVm.mapId);
    });

    $scope.$on("MapPlaceHoverOut", (event, message) => {
      mapService.clearSearchMarker(routeVm.mapId);
    });

    $scope.$on("ShowPin", (event, message) => {
      routeVm.popupLocation = message.location;
      mapService.showPin(message.location, message.pan, $scope, message.mapId);
    });

    $scope.$on("SaveFavorite", (event, message) => { // jshint ignore:line
      routeVm.saveFavorite(message);
    });

    $scope.$on("RemoveSortableItem", (event, index) => {
      routeService.getSelectedRoute().removeSortableItem(index);
    });

    $scope.$on("NewRoute", (event, message) => {
      if (message) {
        routeService.newRoute(message.name, message.stops, message.options, message.savedId, message.uiArrDepSelection, message.isDuplicatedRoute);
      } else {
        routeService.newRoute();
      }
    });

    $scope.$on("RunRoute", () => {
      routeVm.runRoute();
    });

    $scope.$on("$destroy", () => {
      routeService.closeAllReports();
    });

    $window.onbeforeunload = function () {
      routeService.closeAllReports();
    };

    $scope.$on("RouteModified", (event, message) => {
      routeService.routeModified(message.response);
    });

    $scope.$on("RouteModifiedError", (event, message) => {
      routeService.routeModifiedError(message.response);
      $scope.$apply();
    });

    $scope.$on("DragStart", (event, message) => {
      var s = routeService.dragStart(message.feature);

      if (s !== null) {
        s.origLatlon = `${s.Coords.Lat}, ${s.Coords.Lon}`;
        routeVm.tempStop = s;
      }
    });

    $scope.$on("DragEnd", (event, message) => {
      var selectedRoute = routeService.getSelectedRoute();
      selectedRoute.isCalculating = true;
      $scope.$apply();
      addWarnings();
    });

    $scope.$on("DeleteSaveRoutes", (event,opt) => {
      routeVm.routes.forEach((param) => {
        if (param.savedId === opt.deletedRoute.savedId) {
          param.savedId = null;
        }
      });

    });

  }
})();



// WEBPACK FOOTER //
// ./app/route/route.controller.js